module.exports = __webpack_public_path__ + "static/media/bill.d0c680dc.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/bill.svg
// module id = ./src/assets/icons/bill.svg
// module chunks = 0